var __jsx = React.createElement;
import { styled } from '@linaria/react';
import React from 'react';
import { Reset } from '@webtv/css-reset';
import { Fonts } from '@webtv/fonts';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var PageStyles = function PageStyles() {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Global, {}), /*#__PURE__*/_jsx(Reset, {}), /*#__PURE__*/_jsx(Fonts, {})]
  });
};
var Global = /*#__PURE__*/styled("div")({
  name: "Global",
  class: "g1rq6z0k"
});

require("../../../apps/tv/.linaria-cache/packages/@webtv/layout/PageStyles.linaria.module.css");